module.exports = __webpack_public_path__ + "static/2-83b8dc660ac8c42750594870dd07c2b1.jpg";